import type {
  TeamRequestData,
  TeamsQueryParams,
  TeamsResponse
} from '@library/types/teams';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { models } = apiPaths;
export const teamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query<TeamsResponse, TeamsQueryParams>({
      query: ({ leagueId, searchValue, sortBy, sortDir, page, perPage }) => ({
        url: `${models}teams`,
        method: 'GET',
        params: {
          league_id: leagueId,
          page,
          per_page: perPage,
          'q[name_cont]': searchValue,
          sort_by: sortBy,
          sort_dir: sortDir
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    }),
    createTeam: build.mutation<TeamsResponse, TeamRequestData>({
      query: (newTeamData) => ({
        url: `${models}teams`,
        method: 'POST',
        body: { team: newTeamData },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    updateTeam: build.mutation<TeamsResponse, TeamRequestData>({
      query: (updatedTeamData) => ({
        url: `${models}teams/${updatedTeamData.id}`,
        method: 'PUT',
        body: { team: updatedTeamData },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    })
  })
});

export const {
  useGetTeamsQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation
} = teamsApi;
